import { render } from "./KitIdField.vue?vue&type=template&id=363a4436&scoped=true"
import script from "./KitIdField.vue?vue&type=script&lang=js"
export * from "./KitIdField.vue?vue&type=script&lang=js"

import "./KitIdField.vue?vue&type=style&index=0&id=363a4436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363a4436"]])

export default __exports__